import EmailsTimeSeriesService from './EmailsTimeSeries.service';

export const DEFAULT_DIMENSIONS = ['user_data_platform'];
export const MIN_DIMENSIONS = 0;
export const MAX_DIMENSIONS = 1;

export const EVENT_LIST = EmailsTimeSeriesService.getFilteredEventList();
